// 不同断点下的水印
const endPointsWatermarks = [
  // {
  //   // 240
  //   range: [0, 320],
  //   key: 'cHVibGljL2FpLXdhdGVybWFya18yNDAucG5n',
  // },
  // {
  //   // 400
  //   range: [321, 500],
  //   key: 'cHVibGljL2FpLXdhdGVybWFya180MDAucG5n',
  // },
  {
    // 600
    range: [0, 800],
    key: 'cHVibGljL2FpLXdhdGVybWFya182MDAucG5n',
  },
  {
    // 1000
    range: [801, 1300],
    key: 'cHVibGljL2FpLXdhdGVybWFya18xMDAwLnBuZw==',
  },
  {
    // 1600
    range: [1301, 2100],
    key: 'cHVibGljL2FpLXdhdGVybWFya18xNjAwLnBuZw==',
  },
  {
    // 2600
    range: [2101, Infinity],
    key: 'cHVibGljL2FpLXdhdGVybWFya18yNjAwLnBuZw==',
  },
];

export function getFillWatermark(w?: number, h?: number) {
  const longSize = !w || !h ? 1000 : Math.max(w, h);
  const target = endPointsWatermarks.find(({ range }) => {
    return longSize >= range[0] && longSize <= range[1];
  })!;
  return target?.key || 'cHVibGljL2FpLXdhdGVybWFya18xMDAwLnBuZw==';
}
